/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/generate_video_presigned_url/:asset_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdGenerateVideoPresignedUrl } from "./constants";
import type { EngagementAppGroupIdGenerateVideoPresignedUrlResult } from "./types";
import { isEngagementAppGroupIdGenerateVideoPresignedUrlResult } from "./validators";

export const getVideoPresignedUrl = reactQueryFetcherAdapter(
  engagementAppGroupIdGenerateVideoPresignedUrl,
  (
    signal: AbortSignal,
    appGroupId: string,
    assetId: string
  ): Promise<EngagementAppGroupIdGenerateVideoPresignedUrlResult> => {
    return fetch(
      `/engagement/${appGroupId}/generate_video_presigned_url/${assetId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isEngagementAppGroupIdGenerateVideoPresignedUrlResult
);
